<template>
  <div class="container-crud q-px-sm">
    <q-card class="q-px-sm">
      <div style="tw-ml-[30px]">
          <div
            v-for="state in jsonState(forms[0].dadosForm.unitStateSamae)"
            :key="state.id"
            :style="`background-color: ${stateSamae[state.chCodigo].cor}; margin: 3px; padding: 5px 30px; float: left; border-radius: 10px;`"
          >
            {{ state.nmDescricao }}
          </div>
        </div>
      <q-card-section class="row fit q-py-xs">
        <consumer-unit-page
            v-if="showFormUnit"
          ref="consumerUnitForm"
          class="col-12"
          id="analyzeSamae"
          :forms="forms[2]"
          name="consumer-unit-page"
          hidden-buttons
        />
        <div class="row full-width q-col-gutter-lg justify-center q-pt-md">
          <div class="col-lg-2 col-md-3">
            <q-btn
              :disable="!!dadosForm.user"
              class="full-width"
              color="info"
              @click="btAssociar"
            >
              <translate>CONNECT</translate>
            </q-btn>
          </div>
          <div class="col-lg-2 col-md-3">
            <q-btn
              :disable="!dadosForm.user"
              class="full-width"
              color="info"
              @click="btAnalisar"
            >
              <translate>ANALYZE</translate>
            </q-btn>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { messageBox } from 'jtech'
import consumerUnitPage from 'src/modules/consumer-unit/ConsumerUnitPage.vue'
import unitStateSamae from '../UnitStateSamae.config.js'
import SamaeController from '../SamaeController'
import { JtCrud } from 'jtech-webcomps'
const { pageDetail } = JtCrud

@Component({
  name: 'PageShutdown',
  mixins: [pageDetail],
  components: { consumerUnitPage }
})
class PageShutdown extends Vue {
  controller = SamaeController.getInstance();
  stateSamae = unitStateSamae;
  dadosForm = { user: null };
  showFormUnit = false;

  async created () {
    const { adjusted, user } = this.forms[1].dadosForm
    this.dadosForm.adjusted = adjusted
    this.dadosForm.user = user
  }

  async beforeMount () {
    this.showFormUnit = false
    if (this.forms.length < 3) {
      const formsUnit = await Vue.prototype.$jt.repository.resolve('consumerUnit.alterar', { id: this.forms[0].dadosForm.consumerUnit })
      this.forms[2] = formsUnit
      this.forms = [...this.forms]
    }
    this.showFormUnit = true
  }

  async alterPaymentType () {
    if (!this.$refs.jtDynamicForm.isValidForm()) {
      messageBox.warn(this.$gettext('REQUIRED_FIELDS_NOT_FILLED'))
    } else {
      const unitStateSamae = this.modalUnitStateSamae.params.id
      await this.controller.unitStateSamaeUnitDisabled({
        ...this.formsDisabled.dadosForm,
        unitStateSamae
      })
      this.modalUnitStateSamae.disableUnit = false
      this.modalUnitStateSamae.show = false
    }
  }

  btAssociar () {
    this.$q
      .dialog({
        title: this.$gettext('CONFIRMATION'),
        message: this.$gettext(
          'THIS_RECORD_WILL_BE_ASSOCIATED_WITH_YOU'
        ),
        ok: this.$gettext('YES'),
        cancel: this.$gettext('NO'),
        preventClose: true
      })
      .onOk(async () => {
        const data = await this.controller.joinUnit({
          ...this.forms[1].dadosForm
        })
        this.dadosForm.user = data.name
      })
  }

  btAnalisar () {
    if (this.$refs.consumerUnitForm.isValidForm()) {
      this.$emit(
        'action-button',
        { name: 'btAnalisarShutdown' },
        { ...this.forms[1].dadosForm },
        this
      )
    }
  }

  jsonState (state) {
    if (state instanceof Array) {
      return state
    }
    return JSON.parse(state)
  }
}
export default PageShutdown
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.collection-points{
  .q-item{
    min-height: 42px!important;
    border-radius: 3px;
  }
}

.card-row > div {
  padding: 5px 10px;
}

.card-row > div:nth-child(odd) {
  background-color: $ice;
}
</style>
